var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-menu-header"},[_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"text-h6"},[_vm._v(" "+_vm._s(_vm.userModel.fname)+" "+_vm._s(_vm.userModel.lname)+" ")]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.userModel.email))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }